import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Body extends Component {
  componentDidMount = () => {};

  render() {
    const { children } = this.props;
    return (
      <div id="body" className="w-full flex flex-col items-center relative p-4" style={{ marginTop: '72px' }}>
        {children}
      </div>
    );
  }
}

Body.propTypes = {
  children: PropTypes.shape().isRequired,
};
